import React from "react";
import * as S from "./styles";

interface IModalTransfer {
  open: boolean;
  valueTransfer: string;
  handleTransfer: () => void;
  onClose: () => void;
  infoUserTransfer: {
    infoTransfer: { name: string; avatar: string; code: number };
  };
}

const ModalTransfer: React.FC<IModalTransfer> = ({
  open,
  onClose,
  handleTransfer,
  valueTransfer,
  infoUserTransfer,
}) => {
  return (
    <S.ModalMui open={open} onClose={onClose}>
      <S.PaperMui>
        <S.Title>Confirmar Transação</S.Title>

        <S.HighlightBox>
          <S.SubConfirm>Você está enviando:</S.SubConfirm>
          <S.ValueHighlight>
            {valueTransfer}
            <S.TransferIcon />
          </S.ValueHighlight>
        </S.HighlightBox>

        <S.ContainerData>
          {infoUserTransfer.infoTransfer.name && (
            <S.DataRow>
              <S.SubTitle>Para:</S.SubTitle>
              <S.Message>{infoUserTransfer.infoTransfer.name}</S.Message>
            </S.DataRow>
          )}
          {infoUserTransfer.infoTransfer.code && (
            <S.DataRow>
              <S.SubTitle>Código:</S.SubTitle>
              <S.Message>{infoUserTransfer.infoTransfer.code}</S.Message>
            </S.DataRow>
          )}
        </S.ContainerData>

        <S.ButtonContainer>
          <S.CancelButton onClick={onClose} disableElevation>
            Cancelar
          </S.CancelButton>
          <S.ConfirmButton onClick={handleTransfer} disableElevation>
            Confirmar Envio
          </S.ConfirmButton>
        </S.ButtonContainer>
      </S.PaperMui>
    </S.ModalMui>
  );
};

export default ModalTransfer;
